const processOne = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/process-one/application/List.vue')
    },
    {
        path: 'servey-list',
        name: prop + '.servey_list',
        meta: { auth: true },
        component: () => import('../pages/process-one/servey/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/process-one/forward/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/process-one/receive-apps/List.vue')
    },
    {
        path: 'go-applications',
        name: prop + '.go_applications',
        meta: { auth: true },
        component: () => import('../pages/process-one/go-apps/List.vue')
    },
    {
        path: 'issue-go',
        name: prop + '.issue_go',
        meta: { auth: true },
        component: () => import('../pages/process-one/issue-go/List.vue')
    }
]

const processTwo = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/application/List.vue')
    },
    {
        path: 'survey-list',
        name: prop + '.survey_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/survey/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/forward/List.vue')
    },
    {
        path: 'receive-list',
        name: prop + '.receive_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/receive/List.vue')
    },
    {
        path: 'hospital-application-form',
        name: prop + '.hospital_application_form',
        meta: { auth: true },
        component: () => import('../pages/process-two/medical-treatment-hospital/Form.vue')
    },
    {
        path: 'hospital-application-list',
        name: prop + '.hospital_application_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/medical-treatment-hospital/List.vue')
    },
    {
        path: 'pending-application-list',
        name: prop + '.pending_application_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/pending-application/QuarterList.vue')
    },
    {
        path: 'quarter-wise-application-district',
        name: prop + '.quarter_wise_application_district',
        props: true,
        meta: { auth: true },
        component: () => import('../pages/process-two/pending-application-district/ApplicationList.vue')
    },
    {
        path: 'quarter-wise-application',
        name: prop + '.quarter_wise_application',
        props: true,
        meta: { auth: true },
        component: () => import('../pages/process-two/pending-application/ApplicationList.vue')
    },
    {
        path: 'rejected-list',
        name: prop + '.rejected_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/rejected-list/List.vue')
    },
    {
        path: 'inactive-list',
        name: prop + '.inactive_list',
        meta: { auth: true },
        component: () => import('../pages/process-two/inactive-list/List.vue')
    },
    {
        path: 'notice-development',
        name: prop + '.notice_development',
        meta: { auth: true },
        component: () => import('../pages/process-two/notice-development/List.vue')
    },
    {
        path: 'notice-budget-entry',
        name: prop + '.notice_budget_entry',
        meta: { auth: true },
        component: () => import('../pages/process-two/notice-budget-entry/List.vue')
    },
    {
        path: 'cancer-kidney-import',
        name: prop + '.cancer_kidney_import',
        meta: { auth: true },
        component: () => import('../pages/cancer-kidney-import/List.vue')
    },
    {
        path: 'cancer-kidney-import-verify',
        name: prop + '.cancer_kidney_import_verify',
        meta: { auth: true },
        component: () => import('../pages/cancer-kidney-import/Verify.vue')
    },
    {
        path: 'cancer-kidney-import-form',
        name: prop + '.cancer_kidney_import',
        meta: { auth: true },
        component: () => import('../pages/cancer-kidney-import/Form.vue')
    },
    {
        path: 'district-budget',
        name: prop + '.district-budget',
        meta: { auth: true },
        component: () => import('../pages/process-two/district-budget/List.vue')
    },
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/process-two/application-search/List.vue')
    },
    {
        path: 'approve-application-search',
        name: prop + '.approve_application_search',
        meta: { auth: true },
        component: () => import('../pages/process-two/approve-application-search/List.vue')
    }
]

const process = (prop) => [
    {
        path: 'application-details',
        name: prop + '.application_details',
        meta: { auth: true },
        component: () => import('../pages/process/Details.vue')
    }
]

const processThree = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/process-three/application/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/process-three/forward/List.vue')
    },
    {
        path: 'return-list',
        name: prop + '.return_list',
        meta: { auth: true },
        component: () => import('../pages/process-three/return/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/process-three/receive-apps/List.vue')
    }
]

const processFour = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/process-four/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/process-four/recommended/List.vue')
    }
]

const processFive = (prop) => [
    {
        path: 'expense-list',
        name: prop + '.expense_list',
        meta: { auth: true },
        component: () => import('../pages/process-five/List.vue')
    }
]

const jpufGrantPersonal = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/application/List.vue')
    },
    {
        path: 'selected-list',
        name: prop + '.selected_list',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/application/SelectedList.vue')
    },
    {
        path: 'application-selection',
        name: prop + '.application_selection',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/application/Selection.vue')
    },
    {
        path: 'application-approval',
        name: prop + '.application_approval',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/application/Approval.vue')
    },
    {
        path: 'approved-application',
        name: prop + '.approved_application',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/application/ApprovedList.vue')
    },
    {
        path: 'rejected-application',
        name: prop + '.rejected_application',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/application/RejectedList.vue')
    },
    {
        path: 'jpuf-personal-grant-report',
        name: prop + '.jpuf_personal_grant_report',
        meta: { auth: true },
        component: () => import('../pages/jpuf-grant-personal/report/JpufPersonalGrantReport.vue')
    }
]

const jpuf = (prop) => [
    {
        path: 'jpuf-grant-organization',
        name: prop + '.jpuf_grant_organization',
        meta: { auth: true },
        component: () => import('../pages/jpuf/application/List.vue')
    },
    {
        path: 'pre-selection',
        name: prop + '.pre_selection',
        meta: { auth: true },
        component: () => import('../pages/jpuf/pre-selection/List.vue')
    },
    {
        path: 'board-approval',
        name: prop + '.board_approval',
        meta: { auth: true },
        component: () => import('../pages/jpuf/board-approval/List.vue')
    },
    {
        path: 'selection',
        name: prop + '.selection',
        meta: { auth: true },
        component: () => import('../pages/jpuf/selection/List.vue')
    },
    {
        path: 'ministry-approval',
        name: prop + '.ministry_approval',
        meta: { auth: true },
        component: () => import('../pages/jpuf/ministry-approval/List.vue')
    },
    {
        path: 'issue-geo',
        name: prop + '.issue_geo',
        meta: { auth: true },
        component: () => import('../pages/jpuf/issue-geo/List.vue')
    },
    {
        path: 'approved-geo',
        name: prop + '.approved_geo',
        meta: { auth: true },
        component: () => import('../pages/jpuf/approved-geo/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/jpuf/recommended/List.vue')
    },
    {
        path: 'waiting-list',
        name: prop + '.waiting_list',
        meta: { auth: true },
        component: () => import('../pages/jpuf/waiting/List.vue')
    }
]

const grantAllowanceStipendRoute = (prop) => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard.vue')
    },
    {
        path: 'bnswc-circular',
        name: prop + '.bnswc_circular',
        meta: { auth: true },
        component: () => import('../pages/bnswc-circular/List.vue')
    }
]

const privateOrphanageCapitationGrant = (prop) => [
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/application-search/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/application/List.vue')
    },
    {
        path: 'survey-list',
        name: prop + '.survey_list',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/survey/List.vue')
    },
    {
        path: 'survey-approve',
        name: prop + '.survey_approve',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/survey/ProcessDetailsModalApprove.vue')
    },
    {
        path: 'inspection-form',
        name: prop + '.inspection_form',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/survey/Inspection.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/forward/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/receive-apps/List.vue')
    },
    {
        path: 'division-receive-applications',
        name: prop + '.division_receive_applications',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/division-receive-applications/List.vue')
    },
    {
        path: 'head-office-receive-applications',
        name: prop + '.division_receive_applications',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/head-office-receive-applications/List.vue')
    },
    {
        path: 'head-office-propose-details',
        name: prop + '.head_office_propose_details',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/head-office-receive-applications/applicationsDetailsModal.vue')
    },
    {
        path: 'ministry-receive-applications',
        name: prop + '.division_receive_applications',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/ministry-receive-applications/List.vue')
    },
    {
        path: 'ministry-propose-details',
        name: prop + '.ministry_propose_details',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/ministry-receive-applications/applicationsDetailsModal.vue')
    },
    {
        path: 'go-applications',
        name: prop + '.go_applications',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/go-apps/List.vue')
    },
    {
        path: 'issue-go',
        name: prop + '.issue_go',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/issue-go/List.vue')
    },
    {
        path: 'import-registration-file',
        name: prop + '.import_registration_file',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/import-file/registrationFileList.vue')
    },
    {
        path: 'import-previus-kisti-orphans',
        name: prop + '.import_previus_kisti_orphans',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/import-file/previusKistiOrphans.vue')
    },
    {
        path: 'import-registration-application',
        name: prop + '.import_registration_application',
        meta: { auth: true },
        component: () => import('../pages/private-orphanage-capitation-grant/import-registration-application/List.vue')
    }
]

const rehabilitationActivitiesForBurnVictims = (prop) => [
    {
        path: 'budget-preparation',
        name: prop + '.budget_preparation',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/budget-preparation/List.vue')
    },
    {
        path: 'budget-preparation-add',
        name: prop + '.budget_preparation_add',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/budget-preparation/Form.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/application/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/receive-apps/List.vue')
    },
    {
        path: 'approved-applications',
        name: prop + '.approved_applications',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/approved/List.vue')
    },
    {
        path: 'rejected-applications',
        name: prop + '.rejected_applications',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/rejected/List.vue')
    },
    {
        path: 'survey-list',
        name: prop + '.survey_list',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/survey/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/forward/List.vue')
    },
    {
        path: 'go-applications',
        name: prop + '.go_applications',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/go-apps/List.vue')
    },
    {
        path: 'issue-go',
        name: prop + '.issue_go',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/issue-go/List.vue')
    },
    {
        path: 'rehabitation-form',
        name: prop + '.rehabitation_form',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-activities-for-burn-victims/approved/Form.vue')
    }
]

const medicalAssistanceToPersonsWithDisabilitiesAndChildren = (prop) => [
    {
        path: 'circular-list',
        name: prop + '.circular',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/circular/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/application/List.vue')
    },
    {
        path: 'survey-list',
        name: prop + '.survey_list',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/survey/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/forward/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/receive-apps/List.vue')
    },
    {
        path: 'go-applications',
        name: prop + '.go_applications',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/go-apps/List.vue')
    },
    {
        path: 'issue-go',
        name: prop + '.issue_go',
        meta: { auth: true },
        component: () => import('../pages/medical-assistance-to-persons-with-disabilities-and-children/issue-go/List.vue')
    }
]

const grantsToRegisteredGeneralVoluntaryOrganizations = (prop) => [
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/application-search/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/application/List.vue')
    },
    {
        path: 'survey-list',
        name: prop + '.survey_list',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/survey/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/forward/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/receive-apps/List.vue')
    },
    {
        path: 'go-applications',
        name: prop + '.go_applications',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/go-apps/List.vue')
    },
    {
        path: 'issue-go',
        name: prop + '.issue_go',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/issue-go/List.vue')
    },
    {
        path: 'rejected-list',
        name: prop + '.rejected_list',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/rejected-list/List.vue')
    },
    {
        path: 'trucking-list',
        name: prop + '.trucking_list',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization/trucking-list/List.vue')
    }
]

const NationalLevelGrant = (prop) => [
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant/application-search/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant/recommended/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant/approved/List.vue')
    },
    {
        path: 'agreement-list',
        name: prop + '.agreement_list',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant/agreement/List.vue')
    },
    {
        path: 'rejected-list',
        name: prop + '.rejected_list',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant/rejected/List.vue')
    }
]

const CoordinationCouncil = (prop) => [
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/coordination-council/application-search/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/coordination-council/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/coordination-council/recommended/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/coordination-council/approved/List.vue')
    },
    {
        path: 'agreement-list',
        name: prop + '.agreement_list',
        meta: { auth: true },
        component: () => import('../pages/coordination-council/agreement/List.vue')
    },
    {
        path: 'rejected-list',
        name: prop + '.rejected_list',
        meta: { auth: true },
        component: () => import('../pages/coordination-council/rejected/List.vue')
    }
]

const CorrectionOfOffender = (prop) => [
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender/application-search/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender/recommended/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender/approved/List.vue')
    },
    {
        path: 'agreement-list',
        name: prop + '.agreement_list',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender/agreement/List.vue')
    },
    {
        path: 'rejected-list',
        name: prop + '.rejected_list',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender/rejected/List.vue')
    }
]

const PatientWelfareAssociation = (prop) => [
    {
        path: 'application-search',
        name: prop + '.application_search',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/application-search/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/application/List.vue')
    },
    {
        path: 'forward-list',
        name: prop + '.forward_list',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/forward/List.vue')
    },
    {
        path: 'bnswc-applications',
        name: prop + '.bnswc_applications',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/bnswc-applications/List.vue')
    },
    {
        path: 'receive-applications',
        name: prop + '.receive_applications',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/receive-apps/List.vue')
    },
    {
        path: 'go-applications',
        name: prop + '.go_applications',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/go-apps/List.vue')
    },
    {
        path: 'issue-go',
        name: prop + '.issue_go',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/issue-go/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/approved/List.vue')
    },
    // {
    //     path: 'recommended-list',
    //     name: prop + '.recommended_list',
    //     meta: { auth: true },
    //     component: () => import('../pages/patient-welfare-association/recommended/List.vue')
    // },
    // {
    //     path: 'approved-list',
    //     name: prop + '.approved_list',
    //     meta: { auth: true },
    //     component: () => import('../pages/patient-welfare-association/final-approval/List.vue')
    // },
    {
        path: 'rejected-list',
        name: prop + '.rejected_list',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/rejected-list/List.vue')
    },
    {
        path: 'trucking-list',
        name: prop + '.trucking_list',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association/trucking-list/List.vue')
    }
]

const CriminalRehabilitationAssociation = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/criminal-rehabilitation-association/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/criminal-rehabilitation-association/recommended/List.vue')
    }
]

const UcdDevelopment = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/ucd-development/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/ucd-development/recommended/List.vue')
    }
]

const SpecialGrant = (prop) => [
    {
        path: 'reject-list',
        name: prop + '.reject_list',
        meta: { auth: true },
        component: () => import('../pages/special-grant/rejected/List.vue')
    },
    {
        path: 'application-approve-list',
        name: prop + '.application_approve_list',
        meta: { auth: true },
        component: () => import('../pages/special-grant/application-approve/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/special-grant/application/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/special-grant/recommended/List.vue')
    }
]

const routes = [
    {
        path: '/grant-allowance-service/process-one',
        name: 'grant_allowance_service.process_one',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: processOne('grant_allowance_service.process_one')
    },
    {
        path: '/grant-allowance-service/process-two',
        name: 'grant_allowance_service.process_two',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: processTwo('grant_allowance_service.process_two')
    },
    {
        path: '/grant-allowance-service/process-three',
        name: 'grant_allowance_service.process_three',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: processThree('grant_allowance_service.process_three')
    },
    {
        path: '/grant-allowance-service/process-four',
        name: 'grant_allowance_service.process_four',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: processFour('grant_allowance_service.process_four')
    },
    {
        path: '/grant-allowance-service/process-five',
        name: 'grant_allowance_service.process_five',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: processFive('grant_allowance_service.process_five')
    },
    {
        path: '/grant-allowance-service/process',
        name: 'grant_allowance_service.process',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: process('grant_allowance_service.process')

    },
    /** */
    {
        path: '/grant-allowance-service/process/jpuf',
        name: 'grant_allowance_service.process.jpuf',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: jpuf('grant_allowance_service.process.jpuf')
    },
    {
        path: '/grant-allowance-service/jpuf-grant-personal',
        name: 'grant_allowance_service.jpuf_grant_personal',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: jpufGrantPersonal('grant_allowance_service.jpuf_grant_personal')
    },
    {
        path: '/grant-allowance-service/private-orphanage-capitation-grant',
        name: 'grant_allowance_service.private_orphanage_capitation_grant',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: privateOrphanageCapitationGrant('grant_allowance_service.private_orphanage_capitation_grant')
    },
    {
        path: '/grant-allowance-service/rehabilitation-activities-for-burn-victims',
        name: 'grant_allowance_service.rehabilitation_activities_for_burn_victims',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: rehabilitationActivitiesForBurnVictims('grant_allowance_service.rehabilitation_activities_for_burn_victims')
    },
    {
        path: '/grant-allowance-service/medical-assistance-to-persons-with-disabilities-and-children',
        name: 'grant_allowance_service.medical_assistance_to_persons_with_disabilities_and_children',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: medicalAssistanceToPersonsWithDisabilitiesAndChildren('grant_allowance_service.medical_assistance_to_persons_with_disabilities_and_children')
    },
    {
        path: '/grant-allowance-service/registered-general-voluntary-organization',
        name: 'grant_allowance_service.registered_general_voluntary_organization',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: grantsToRegisteredGeneralVoluntaryOrganizations('grant_allowance_service.registered_general_voluntary_organization')
    },
    {
        path: '/grant-allowance-service/national-level-grant',
        name: 'grant_allowance_service.national_level_grant',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: NationalLevelGrant('grant_allowance_service.national_level_grant')
    },
    {
        path: '/grant-allowance-service/coordination-council',
        name: 'grant_allowance_service.coordination_councilt',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: CoordinationCouncil('grant_allowance_service.coordination_councilt')
    },
    {
        path: '/grant-allowance-service/correction-of-offender',
        name: 'grant_allowance_service.correction_of_offender',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: CorrectionOfOffender('grant_allowance_service.correction_of_offender')
    },
    {
        path: '/grant-allowance-service/patient-welfare-association',
        name: 'grant_allowance_service.patient_welfare_association',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: PatientWelfareAssociation('grant_allowance_service.patient_welfare_association')
    },
    {
        path: '/grant-allowance-service/criminal-rehabilitation-association',
        name: 'grant_allowance_service.criminal_rehabilitation_association',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: CriminalRehabilitationAssociation('grant_allowance_service.criminal_rehabilitation_association')
    },
    {
        path: '/grant-allowance-service/ucd-development',
        name: 'grant_allowance_service.ucd_development',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: UcdDevelopment('grant_allowance_service.ucd_development')
    },
    {
        path: '/grant-allowance-service/special-grant',
        name: 'grant_allowance_service.special_grant',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: SpecialGrant('grant_allowance_service.special_grant')
    },
    /** */
    {
        path: '/grant-allowance-service/allowance-stipend-and-grant-management',
        name: 'grant_allowance_service.allowance_stipend_and_grant_management',
        component: () => import('@/layouts/GrantAllowanceLayout.vue'),
        meta: { auth: true },
        children: grantAllowanceStipendRoute('grant_allowance_service.allowance_stipend_and_grant_management')

    }
]

export default routes
